module.exports = __webpack_public_path__ + "img/events.e9488ef9.png";